import React, { useState, useRef, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import Meeting_Default from "./meeting_details";
import Filterdrop from "./filterdrop";
import CryptoJS from "crypto-js";
import "./meetings.css";

const Meetings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const [open, setOpen] = useState({});

  const [filterOpen, setFilteropen] = useState(false);

  const [filters, setFilters] = useState([false, false, false, false]);
  const [meetings, setMeetings] = useState([]);

  const handleFilterChange = (index) => {
    const newFilters = filters.map((filter, i) =>
      i === index ? !filter : false
    );
    setFilters(newFilters);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.classList.contains("filtercls")) {
        setFilters([false, false, false, false]);
      }
    };
    document.addEventListener("click", handleClickOutside);
  }, []);
  const alljobs_arr = [
    "UX Designer",
    "Software Developer",
    "Senior Copywriter",
    "Product Manager",
    "Demo1",
    "Demo2",
  ];
  const allworkspaces_arr = [
    "Workspace 1",
    "Workspace 2",
    "Workspace 3",
    "Workspace 4",
  ];
  const activeevent = ["Active Event", "Cancel Event"];
  const allinviteemail = [
    "abhat@gmail.com",
    "abhat@gmail.com",
    "abhat@gmail.com",
    "abhat@gmail.com",
  ];

  const [activeTab, setActiveTab] = useState("Upcoming");

  const navItems = ["Upcoming", "Past"];

  const changeActive = (tabName) => {
    setActiveTab(tabName);
  };

  useEffect(() => {
    meetingDetails();
  }, [activeTab]);

  function set_acc(childIndex, parentIndex) {
    // const newOpen = open.map((filter, i) => i === index ? !filter : false);
    setOpen((prevOpen) => {
      const newOpen = {};
      const isSameIndex =
        prevOpen[parentIndex] && prevOpen[parentIndex][childIndex] === true;
      if (!isSameIndex) {
        newOpen[parentIndex] = Array(childIndex + 1).fill(false);
        newOpen[parentIndex][childIndex] = true;
      }
      return newOpen;
    });
  }

  useEffect(() => {
    setOpen(Array(meetings.length).fill(false));
  }, [meetings]);

  const [isMeetingfetch, setIsMeetingfetch] = useState(false);
  const [time, setTime] = useState({});
  function formatDate(isoDate) {
    const date = new Date(isoDate);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
  const convertTo12HourFormat = (time) => {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };
  const meetingDetails = async () => {
    setIsMeetingfetch(true);
    const encryptedMetadata = localStorage.getItem("metadata");
    if (!encryptedMetadata) return;

    const decryptedMetadata = JSON.parse(
      CryptoJS.AES.decrypt(
        encryptedMetadata,
        process.env.REACT_APP_SECRETKEY
      ).toString(CryptoJS.enc.Utf8)
    );

    const type = activeTab.toLowerCase();

    const cardContent = { company_id: decryptedMetadata.cid, type: type };
    const encryptedDashData = CryptoJS.AES.encrypt(
      JSON.stringify(cardContent),
      process.env.REACT_APP_SECRETKEY
    ).toString();

    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/calendly/fetchScheduleDetails`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", token },
          body: JSON.stringify({ data: encryptedDashData }),
        }
      );

      const rawData = await response.text();
      const responsedata = JSON.parse(rawData);
      console.log(responsedata, "responsedata");

      if (!response.ok)
        throw new Error(responsedata.error || "Something went wrong");

      const decryptedData = responsedata.data;

      const meetingsData = Object.entries(decryptedData).flatMap(
        ([date, meetingsForDate]) => {
          return meetingsForDate.map((meeting) => {
            const date = new Date(meeting.date);

            const [startHour, startMinute, startSecond] = meeting.start_time
              .split(":")
              .map(Number);
            const [endHour, endMinute, endSecond] = meeting.end_time
              .split(":")
              .map(Number);

            const formattedStartTime = new Date(date);
            formattedStartTime.setHours(startHour, startMinute, startSecond);

            const formattedEndTime = new Date(date);
            formattedEndTime.setHours(endHour, endMinute, endSecond);

            const timeZone = "Asia/Kolkata";
            const dateValue =
              date
                .toLocaleString("en-CA", {
                  timeZone,
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hourCycle: "h23",
                })
                .replace(", ", "T") + "+05:30";

            const startDateTime =
              formattedStartTime
                .toLocaleString("en-CA", {
                  timeZone,
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hourCycle: "h23",
                })
                .replace(", ", "T") + "+05:30";

            const endDateTime =
              formattedEndTime
                .toLocaleString("en-CA", {
                  timeZone,
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hourCycle: "h23",
                })
                .replace(", ", "T") + "+05:30";
            return {
              id: meeting.aid,
              name: meeting.name,
              title: meeting.job_details?.title,
              start_time: meeting.start_time,
              end_time: meeting.end_time,
              interviewer_id: meeting.interviewer_id,
              email: meeting.created_by,
              question: meeting.query,
              job_id: meeting.job_id,
              zone: meeting.job_details?.timezone,
              create_at: meeting.job_details?.created_at
                ? new Intl.DateTimeFormat("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  }).format(new Date(meeting.job_details.created_at))
                : "Unknown Date",
              meeting_link: meeting.meeting_link,
              job_desc: meeting.job_details?.job_desc,
              interviewer_name: meeting.interviewer_name,
              date: dateValue,
              start_time: convertTo12HourFormat(meeting.start_time),
              end_time: convertTo12HourFormat(meeting.end_time),
              can_id: meeting.candidate_id,
              start: {
                dateTime: startDateTime,
                timeZone,
              },
              end: {
                dateTime: endDateTime,
                timeZone,
              },
              attendees: meeting.created_by,
            };
          });
        }
      );
      setMeetings(meetingsData);
      setTime({
        start: meetingsData[0]?.start,
        end: meetingsData[0]?.end,
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsMeetingfetch(false);
      setIsLoading(false);
    }
  };

  const groupedMeetings = meetings.reduce((acc, meeting) => {
    const meetingDate = new Date(meeting.date).toLocaleDateString("en-GB");
    if (!acc[meetingDate]) {
      acc[meetingDate] = [];
    }
    acc[meetingDate].push(meeting);
    return acc;
  }, {});

  const groupedMeetingsArray = Object.entries(groupedMeetings).map(
    ([date, meetingsForDate]) => {
      return {
        date,
        meetings: meetingsForDate,
      };
    }
  );

  return (
    <>
      <div className="ml-0 lg:ml-[5%] mt-4 lg:mt-8 py-4 px-2 sm:px-4 rounded-xl bg-white bg-opacity-50">
        <h4 className="text-lg sm:text-xl font-semibold mb-4">Meetings</h4>
        <div
          className="flex w-full justify-left mt-6"
          style={{ borderBottom: "1px solid grey" }}
        >
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => changeActive(item)}
              className={`mx-2 sm:mx-4 py-2 text-base sm:text-lg ${
                activeTab === item
                  ? "text-green-600 border-b-4 border-green-600"
                  : "text-gray-600"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
        {filterOpen && (
          <div className="flex flex-col lg:flex-row w-full mt-3 px-2 sm:px-4 gap-4 lg:gap-0">
            <div className="flex flex-col sm:flex-row lg:items-center lg:justify-between w-full lg:w-4/6 gap-4 sm:gap-2 lg:gap-0 lg:pl-2">
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-[#747474] text-[12px] sm:text-[14px] font-normal plusJakartaSansFont mb-1">
                  Job
                </span>
                <div>
                  <button
                    id="dropdownDefaultButton"
                    onClick={() => handleFilterChange(0)}
                    className="text-[#059669] font-medium rounded-lg text-xs sm:text-sm text-center flex items-center justify-between w-full plusJakartaSansFont filtercls"
                    type="button"
                  >
                    <span className="truncate">All Jobs</span>
                    <svg
                      className={
                        filters[0]
                          ? "rotate-180 filtercls ml-2 flex-shrink-0"
                          : "filtercls ml-2 flex-shrink-0"
                      }
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_489_198002)">
                        <g clipPath="url(#clip1_489_198002)">
                          <path
                            d="M4 6.5L7.58579 10.0858C8.25245 10.7525 8.58579 11.0858 9 11.0858C9.41421 11.0858 9.74755 10.7525 10.4142 10.0858L14 6.5"
                            stroke="#059669"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_489_198002">
                          <rect width="18" height="18" fill="#059669" />
                        </clipPath>
                        <clipPath id="clip1_489_198002">
                          <rect
                            width="18"
                            height="18"
                            fill="#059669"
                            transform="translate(18 18) rotate(180)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  {filters[0] && (
                    <Filterdrop
                      filterClass="filtercls"
                      drop_data={alljobs_arr}
                      id="alljobs"
                      search={true}
                    />
                  )}
                </div>
              </div>
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-[#747474] text-[12px] sm:text-[14px] font-normal plusJakartaSansFont mb-1">
                  Workspace
                </span>
                <div>
                  <button
                    id="dropdownDefaultButton"
                    onClick={() => handleFilterChange(1)}
                    className="text-[#059669] font-medium rounded-lg text-xs sm:text-sm text-center flex items-center justify-between w-full plusJakartaSansFont filtercls"
                    type="button"
                  >
                    <span className="truncate">All Workspaces</span>
                    <svg
                      className={
                        filters[1]
                          ? "rotate-180 filtercls ml-2 flex-shrink-0"
                          : "filtercls ml-2 flex-shrink-0"
                      }
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_489_198002)">
                        <g clipPath="url(#clip1_489_198002)">
                          <path
                            d="M4 6.5L7.58579 10.0858C8.25245 10.7525 8.58579 11.0858 9 11.0858C9.41421 11.0858 9.74755 10.7525 10.4142 10.0858L14 6.5"
                            stroke="#059669"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_489_198002">
                          <rect width="18" height="18" fill="#059669" />
                        </clipPath>
                        <clipPath id="clip1_489_198002">
                          <rect
                            width="18"
                            height="18"
                            fill="#059669"
                            transform="translate(18 18) rotate(180)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  {filters[1] && (
                    <Filterdrop
                      filterClass="filtercls"
                      drop_data={allworkspaces_arr}
                      id="allworkspaces"
                      search={true}
                    />
                  )}
                </div>
              </div>
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-[#747474] text-[12px] sm:text-[14px] font-normal plusJakartaSansFont mb-1">
                  Status
                </span>
                <div>
                  <button
                    id="dropdownDefaultButton"
                    onClick={() => handleFilterChange(2)}
                    className="text-[#059669] font-medium rounded-lg text-xs sm:text-sm text-center flex items-center justify-between w-full plusJakartaSansFont filtercls"
                    type="button"
                  >
                    <span className="truncate">Active Event</span>
                    <svg
                      className={
                        filters[2]
                          ? "rotate-180 filtercls ml-2 flex-shrink-0"
                          : "filtercls ml-2 flex-shrink-0"
                      }
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_489_198002)">
                        <g clipPath="url(#clip1_489_198002)">
                          <path
                            d="M4 6.5L7.58579 10.0858C8.25245 10.7525 8.58579 11.0858 9 11.0858C9.41421 11.0858 9.74755 10.7525 10.4142 10.0858L14 6.5"
                            stroke="#059669"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_489_198002">
                          <rect width="18" height="18" fill="#059669" />
                        </clipPath>
                        <clipPath id="clip1_489_198002">
                          <rect
                            width="18"
                            height="18"
                            fill="#059669"
                            transform="translate(18 18) rotate(180)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  {filters[2] && (
                    <Filterdrop
                      filterClass="filtercls"
                      drop_data={activeevent}
                      id="activeevent"
                      search={false}
                    />
                  )}
                </div>
              </div>
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-[#747474] text-[12px] sm:text-[14px] font-normal plusJakartaSansFont mb-1">
                  Invitee Email ID
                </span>
                <div>
                  <button
                    id="dropdownDefaultButton"
                    onClick={() => handleFilterChange(3)}
                    className="text-[#059669] font-medium rounded-lg text-xs sm:text-sm text-center flex items-center justify-between w-full plusJakartaSansFont filtercls"
                    type="button"
                  >
                    <span className="truncate">All Invitee Emails</span>
                    <svg
                      className={
                        filters[3]
                          ? "rotate-180 filtercls ml-2 flex-shrink-0"
                          : "filtercls ml-2 flex-shrink-0"
                      }
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_489_198002)">
                        <g clipPath="url(#clip1_489_198002)">
                          <path
                            d="M4 6.5L7.58579 10.0858C8.25245 10.7525 8.58579 11.0858 9 11.0858C9.41421 11.0858 9.74755 10.7525 10.4142 10.0858L14 6.5"
                            stroke="#059669"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_489_198002">
                          <rect width="18" height="18" fill="#059669" />
                        </clipPath>
                        <clipPath id="clip1_489_198002">
                          <rect
                            width="18"
                            height="18"
                            fill="#059669"
                            transform="translate(18 18) rotate(180)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  {filters[3] && (
                    <Filterdrop
                      filterClass="filtercls"
                      drop_data={allinviteemail}
                      id="allinviteemail"
                      search={true}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="flex items-center justify-center lg:justify-end w-full lg:w-2/6 mt-4 lg:mt-0">
              <span className="plusJakartaSansFont text-[#059669] font-medium text-[12px] sm:text-[14px] cursor-pointer hover:underline">
                Clear all Filters
              </span>
            </div>
          </div>
        )}

        <div className="flex flex-col gap-4">
          {isMeetingfetch ? (
            <div className="loader-container">
              <div className="spinner"></div>
              <h4>Fetching Meeting Details...</h4>
            </div>
          ) : (
            <div>
              {groupedMeetingsArray.length > 0 ? (
                groupedMeetingsArray.map((group, groupIdx) => (
                  <div key={groupIdx}>
                    <div className="mt-3">
                      <p className="plusJakartaSansFont font-medium text-sm sm:text-base text-[#3D3D3D]">
                        {group.date}
                      </p>
                    </div>
                    {group.meetings.length > 0 ? (
                      group.meetings.map((meeting, idx) => (
                        <div
                          key={meeting.id}
                          className="bg-white mb-2"
                          style={{
                            boxShadow: "0px 4px 40px 0px #00000014",
                            padding: "15px sm:20px",
                            borderRadius: "15px sm:20px",
                          }}
                        >
                          <div
                            className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 cursor-pointer"
                            onClick={() => set_acc(idx, groupIdx)}
                          >
                            {/* Name - Full width on mobile */}
                            <div className="flex-shrink-0 sm:flex-1">
                              <p className="m-0 plusJakartaSansFont font-bold text-lg sm:text-xl text-[#1D1D1D] truncate">
                                {meeting.name}
                              </p>
                            </div>

                            {/* Job, Time, Interviewer - Stack on mobile, horizontal on desktop */}
                            <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 flex-1 sm:flex-none">
                              {/* Job */}
                              <div className="flex flex-col sm:flex-col">
                                <span className="font-medium plusJakartaSansFont text-xs sm:text-sm text-[#747474]">
                                  Job
                                </span>
                                <span className="font-medium text-xs sm:text-sm text-[#3D3D3D] truncate">
                                  {meeting.title}
                                </span>
                              </div>

                              {/* Time */}
                              <div className="flex flex-col sm:flex-col">
                                <span className="font-medium plusJakartaSansFont text-xs sm:text-sm text-[#747474]">
                                  Time
                                </span>
                                <span className="font-medium text-xs sm:text-sm text-[#3D3D3D]">
                                  {meeting.start_time} - {meeting.end_time}
                                </span>
                              </div>

                              {/* Interviewer */}
                              <div className="flex flex-col sm:flex-col">
                                <span className="font-medium plusJakartaSansFont text-xs sm:text-sm text-[#747474]">
                                  Interviewer
                                </span>
                                <span className="font-medium text-xs sm:text-sm text-[#3D3D3D] truncate">
                                  {meeting.interviewer_name}
                                </span>
                              </div>
                            </div>

                            {/* Details button */}
                            <div className="flex items-center justify-center sm:justify-end gap-1 text-[#059669] font-medium text-sm sm:text-base flex-shrink-0">
                              <span>Details</span>
                              <svg
                                className={`${
                                  open[groupIdx]?.[idx] ? "rotate-180" : ""
                                } transition-transform duration-200`}
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 4V20M12 20L18 14M12 20L6 14"
                                  stroke="#059669"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                          {open[groupIdx]?.[idx] && (
                            <div className="mt-4">
                              <Meeting_Default
                                email={meeting.email}
                                qus={meeting.question}
                                index={idx}
                                zone={meeting.zone}
                                create_at={meeting.create_at}
                                meeting_link={meeting.meeting_link}
                                job_id={meeting.job_id}
                                status={activeTab.toLowerCase()}
                                job_desc={meeting.job_desc}
                                interviewer={meeting.interviewer_name}
                                date={meeting.date}
                                time={time}
                                attendees={meeting.attendees}
                                title={meeting.title}
                                name={meeting.name}
                                candidate_id={meeting.can_id}
                                startTime={meeting.start_time}
                              />
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-gray-500 text-base sm:text-lg font-medium py-8">
                        No {activeTab.toLowerCase()} meetings are available.
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 text-base sm:text-lg font-medium py-8">
                  No {activeTab.toLowerCase()} meetings are available.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Meetings;
